import { ReminderForm } from "../ReminderForm";

export interface AddReminderProps {}

export const AddReminder = () => {
  return <ReminderForm />;
};
